import type { Car, CarAusstattungKey } from '../../../../_types/Car';

const ausCategoryMap: Record<string, CarAusstattungKey> = {
    // DE
    'Assistenzsysteme': 'assistenz',
    'Aussen': 'aussen',
    'Fußnoten': 'fussnoten',
    'Highlights': 'highlights',
    'Innen': 'innen',
    'Multimedia': 'multimedia',
    'Pakete': 'pakete',
    'Räder + Reifen': 'raeder',
    'Scheinwerfer + Leuchten': 'scheinwerfer',
    'Sitze + Polster': 'sitze',
    'Sonstiges': 'sonstiges',
    'Technik + Sicherheit': 'technik',

    // EN
    'assistance systems': 'assistenz',
    'Outside': 'aussen',
    'Foot notes': 'fussnoten',
    'highlights': 'highlights',
    'Inside': 'innen',
    'multimedia': 'multimedia',
    'Packages': 'pakete',
    'wheels + tires': 'raeder',
    'headlights + lights': 'scheinwerfer',
    'Seats + upholstery': 'sitze',
    'Miscellaneous': 'sonstiges',
    'technology + security': 'technik',

    // FR
    "Systèmes d'assistance": 'assistenz',
    'Extérieur': 'aussen',
    'Notes de bas de page': 'fussnoten',
    'Intérieur': 'innen',
    'Multimédia': 'multimedia',
    'Packs': 'pakete',
    'Roues + pneus': 'raeder',
    'Phares + feux': 'scheinwerfer',
    'Sièges + garnitures': 'sitze',
    'Autres': 'sonstiges',
    'Technique + sécurité': 'technik',
};

export default function prepareAccessoires(aus: Car<false>['ausstattung']): Car<true>['ausstattung'] {
    const newAus: Car<true>['ausstattung'] = {};

    Object.keys(aus || {})?.map((key) => {
        newAus[ausCategoryMap[key]] = aus[key];
    });

    return newAus;
}
